import React from 'react';

import { PageHeader } from './components/Header'
import { PageFooter } from './components/Footer'
import { ColorContrastPage } from './color-contrast/page';
import './App.css';


export default function App() {
    return (
        <>
            <PageHeader />
            <ColorContrastPage />
            <PageFooter />
        </>
    );
}
